import React from "react";

export class PokerRakebackBody extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            tabs: ['Pravila', 'Uvjeti'],
            selectedTab: null,
            tuniri: null,
            showTurnir: null,
            turnirPobjednici: null
        }


        this.gotoTab = this.gotoTab.bind(this);
        this.getBody = this.getBody.bind(this);
        this.showTurnirRezultati = this.showTurnirRezultati.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.fetchTurnirRezultatiData = this.fetchTurnirRezultatiData.bind(this);
        this.setData = this.setData.bind(this);
        this.setTurnirPobjediniciData = this.setTurnirPobjediniciData.bind(this);
        casino.utils.createPageGoogleTagManagerEvent('Bonusi', 'Rakeback', 'poker', this.props.user);
    }


    showTurnirRezultati(turnir) {
        this.setState({
            showTurnir: turnir,
            turnirPobjednici: null
        });

        this.fetchTurnirRezultatiData(turnir);
    }
    componentDidMount() {
        this.gotoTab(this.state.tabs[0]);
        this.fetchData();
    }
    fetchData() {
        this.props.showLoadingFn(true);

        var promises = Promise.all([casino.repos.pokerSSOPLTurniriRepo.list()]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }

    fetchTurnirRezultatiData(turnir) {
        this.props.showLoadingFn(true);

        var promises = Promise.all([casino.repos.pokerSSPOLTurnirPobjedniciRepo.list(turnir)]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setTurnirPobjediniciData, function (reason) { });
    }
    componentWillUnmount() {
        if (this.dataPromises)
            this.dataPromises.cancel();
    }
    setData(data) {
        var [turniri] = data;

        this.setState({
            turniri: turniri
        });

        this.props.showLoadingFn(false);
    }
    setTurnirPobjediniciData(data) {
        var [pobjedinici] = data;

        this.setState({
            turnirPobjednici: pobjedinici
        });

        this.props.showLoadingFn(false);
    }
    gotoTab(tab) {
        this.setState({ selectedTab: tab });
    }
    getBody() {

        if (this.state.selectedTab == 'Pravila') {
            return <div>
                <div className="padding-sides-medium-2">
                    <h2 className="v3">{this.state.selectedTab}</h2>
                    <div>


                        Ljetni RakeBack!     <br></br>
                        Tijekom srpnja i kolovoza nagrađujemo igrače sa <b>20% ili 30% RakeBack-a!</b>

                        <br></br>
                        <br></br>

                        Samo igrajte i <b>20% Rakebacka je Vaše</b>, ali ako igrate malo više i odigrate minimalno 10 000 kn Rake-a, <b>vaša nagrada je 30%.</b>
                        <br></br>
                        <br></br>
                        Ako slučajno ne znate - Rake je naziv za proviziju koju SuperSport naplaćuje od svake odigrane ruke u kojoj igrači na Poker stolovima vide Flop. Rakeback je naziv bonusa!
                        <br></br>
                        <br></br>
                        Za vrijeme trajanje promocije, Supersport će vam isplatiti <b>20% iznosa Rake-a</b> (RakeBack) s kojim ste sudjelovali u kvalificiranim rukama, a ako ste igrali više i osvojili 2000 kn Rakebacka automatski osvajate dodatni bonus od 10% pa ukupno <b>osvajate 30% Rakebacka</b> (Npr., Igrač koji je napravio 10.000kn Rake-a i 2.000kn RakeBack-a (20%) dobiva dodatnih 1.000kn (10%) RakeBack bonusa za ukupno 3.000kn Bonusa.)
                        <br></br>
                        <br></br>

                        RakeBack se isplaćuje <b>prvi radni dan u kolovozu i rujnu</b> za prethodnih mjesec svim igračima koji su igrali Cash na Poker stolovima.
                        <br></br>
                        <br></br>


                        Skrati vruće ljetne dane uz Poker  i neka najbolji igrač pobijedi!

                    </div>
                </div>

            </div>
        }

        if (this.state.selectedTab == 'Uvjeti')
            return <div>
                <div className="padding-sides-medium-2">
                    <h2 className="v3">{this.state.selectedTab}</h2>
                    <div>
                    </div><ul className="list">
                        <li>Supersport zadržava pravo promijeniti pravila bonusa u bilo kojem trenutku.</li>
                        <li>Prilikom bonusa se primjenjuju standardna pravila i uvjeti korištenja.</li>
                    </ul>
                </div>
            </div>
    }

    render() {
        return <div>
            <div className="segment v2 margin-top-small padding-sides-medium-2">
                {this.state.tabs && this.state.tabs.map((tab) =>
                    <button key={tab} onClick={() => this.gotoTab(tab)} className={'segment--btn' + (this.state.selectedTab === tab ? ' selected' : '')}><span>{tab}</span></button>
                )}
            </div>
            {this.getBody()}
            <div className="text-center ">

                <br />
                <a className="btn medium fill gray blue margin-top margin-bottom no-text-transform" target="_blank" href={'https://cdn.supersport.hr/Casino/Poker/Pravila/RakeBack_Ljeto_2021.pdf' + '?c=' + casino.config.guiCacheVerzija}>
                    <span >Pravila igre</span> <span className="icon ico-expand-outline"></span>
                </a>
            </div>
        </div>


    }
};
